/**
 * Full-screen drag-drop indicator. Only renders while files are being dragged
 * over an object-browser route — actual drop handling lives in ObjectBrowser.
 */

import { Icon } from './brand';

export function DragOverlay({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <div className="bm-drag-overlay" role="presentation">
      <div className="bm-drag-overlay-inner">
        <div className="bm-drag-icon">
          <Icon.upload size={28} />
        </div>
        <div
          className="h-card"
          style={{
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Drop to upload
        </div>
        <div className="muted" style={{ fontSize: 12 }}>
          Files upload directly to the bucket via a presigned URL.
        </div>
      </div>
    </div>
  );
}
